import { IPlan } from '@leedpulse-monorepo/interfaces';
import HttpClient from '../../../core/HttpClient';
import getPlanById from './getPlanById';
import { EProductType } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

/**
 * Fetch Leedflow plans from the backend via Algolia, then resolve full
 * `Plan` instances from Firestore using `getPlanById`.
 *
 * Le backend est responsable du filtrage:
 *   - product === EProductType.LEEDFLOW
 *   - active === true (activeOnly=true)
 *   - archived !== true
 */
async function searchPlans(authentication: Authentication | null): Promise<IPlan[]> {
  const params = new URLSearchParams({
    q: '',
    page: '0',
    hitsPerPage: '100',
    product: EProductType.LEEDFLOW,
    active: 'true',
    archived: 'false',
    partner_systems: JSON.stringify([]),
  });

  if (!authentication) {
    throw new Error('Authentication is required');
  }

  // Algolia renvoie un objet brut { hits, nbHits, ... }
  const json = await HttpClient.get(
    `/algolia/search/frontendleedflow/plans?${params.toString()}`,
    authentication.token
  );

  const hits: Array<{ objectID: string }> = json?.hits ?? [];
  const uniqueIds = Array.from(
    new Set(hits.map((h) => h.objectID).filter(Boolean))
  );

  const plans: IPlan[] = [];
  for (const id of uniqueIds) {
    // We rely on existing Firestore-backed use case to build the domain model
    const plan = await getPlanById(id);
    if (plan) {
      plans.push(plan);
    } else {
      plans.push(hits.find((h) => h.objectID === id)  as unknown as IPlan);
    }
  }

  return plans;
}

export default searchPlans;

